import { useState } from 'react'

/**
 * 依日期分組的 tab 切換列，自動預選「今天」對應的分頁：
 * - 若今天落在某一天，預選當天
 * - 若今天早於第一天（活動尚未開始），預選第一天
 * - 若今天晚於最後一天（活動已結束），預選最後一天
 *
 * days: [{ year, month, date, weekday, ...其餘內容欄位 }]
 * renderDay: (day) => ReactNode，渲染選中那天的內容
 */
export default function ScheduleDayTabs({ days, renderDay, isChallengePage = false }) {
  const [activeIndex, setActiveIndex] = useState(() => getDefaultActiveIndex(days))
  const activeDay = days[activeIndex]

  return (
    <div className="flex flex-col self-stretch" style={{ gap: 16 }}>
      <div className="flex items-stretch self-stretch">
        {days.map((day, idx) => {
          const isOn = idx === activeIndex
          return (
            <button
              key={`${day.year}-${day.month}-${day.date}`}
              type="button"
              onClick={() => setActiveIndex(idx)}
              className="flex-1 flex items-center justify-center"
              style={{
                padding: '8px',
                borderBottom: isOn ? '4px solid #BC313D' : '1px solid rgba(188,49,61,0.12)',
                fontFamily: 'Noto Sans TC',
                fontSize: 18,
                fontWeight: isOn ? 500 : 300,
                color: isOn ? '#BC313D' : 'rgba(188,49,61,0.50)',
              }}
            >
              {isChallengePage === true ? (<>{day.month}/{day.date} ({day.weekday}) {day.date === "12" ? '照客組' : '機動組'}</>) : (<>{day.month}/{day.date} ({day.weekday}) </>)}
            </button>
          )
        })}
      </div>

      {renderDay(activeDay)}
    </div>
  )
}

function getDefaultActiveIndex(days) {
  const today = new Date()
  today.setHours(0, 0, 0, 0)

  const dayTimestamps = days.map((day) => new Date(day.year, day.month - 1, day.date).getTime())
  const todayTime = today.getTime()

  const exactIndex = dayTimestamps.findIndex((t) => t === todayTime)
  if (exactIndex !== -1) return exactIndex

  if (todayTime < dayTimestamps[0]) return 0
  if (todayTime > dayTimestamps[dayTimestamps.length - 1]) return dayTimestamps.length - 1

  // 落在活動期間內但不是任何一天的 00:00（理論上不會發生，保底回傳最後一個 <= today 的天數）
  let fallback = 0
  dayTimestamps.forEach((t, idx) => {
    if (t <= todayTime) fallback = idx
  })
  return fallback
}
